export const stage = process.env.REACT_APP_ENV === 'prod' ? 'prod' : 'dev';
